<template>
  <div id="loading-background" class="app-loading">
    <div class="loading-content">
      <img src="//static.jbisumari.org/jsg/assets/images/logo-jbi-sumari.svg" alt="JBI SUMARI" class="loading-logo" />
      <div class="loading-indicator"></div>
      <div class="loading-text">{{ loadingText }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class AppLoader extends Vue {
  @Prop({ default: 'Loading Screening...' })
  loadingText!: string;
}
</script>

<style lang="scss" scoped>
.app-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.loading-logo {
  width: 180px;
  height: auto;
  margin-bottom: 32px;
}

.loading-indicator {
  width: 50px;
  height: 50px;
  box-sizing: border-box;
  border: 3px solid transparent;
  border-radius: 50%;
  border-left-color: #21b5ea;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 20px;
  color: #6c757d;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Open Sans', 'Source Sans Pro', sans-serif;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style> 